<template>
	<v-row class="pt-5" v-if="doc">
		<v-col cols="10" offset="1">
			<div class="relative">
				<CompetitionMatrix
					:matrix="doc"
					:axis1="axis1"
					:axis2="axis2"
					:min="-10"
					:max="-10"
					:reference="false"
					class="fixed-top z-1"
					name="live"
					:editMode="editMode"
				/>
				<CompetitionMatrix
					:matrix="matrix"
					:axis1="axis1"
					:axis2="axis2"
					:min="-10"
					:max="-10"
					:reference="true"
					class="fixed-top z-0"
					name="refs"
					:editMode="editMode"
				/>
			</div>
		</v-col>
	</v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require('@/firebaseConfig.js');
import { mapState } from 'vuex';
import { CompetitionMatrix } from '@/views/user/exercises/competition';

export default {
	name: 'ResultsTravelUser',
	data() {
		return {
			doc: null,
			refs: null,
			axis1: {
				from: this.$t(`${this.slug}.axis1.from`),
				to: this.$t(`${this.slug}.axis1.to`),
			},
			axis2: {
				from: this.$t(`${this.slug}.axis2.from`),
				to: this.$t(`${this.slug}.axis2.to`),
			},
			min: -10,
			max: 10,
		};
	},
	props: {
		uid: String,
		id: String,
		matrix: {
			type: Object,
			default: () => ({}),
		},
		editMode: {
			type: Boolean,
			default: false,
		},
		slug: {
			type: String,
			default: '',
		},
	},
	watch: {
		uid(val) {
			if (val) {
				this.getExercise();
			}
		},
	},
	mounted() {
		if (this.uid) {
			this.getExercise();
		}
	},
	components: {
		CompetitionMatrix,
	},
	computed: {
		...mapState([
			'userProfile',
			'currentUser',
			'currentProject',
			'currentProjectModel',
		]),
	},
	methods: {
		getExercise() {
			this.doc = null;
			console.log(this.id, this.uid);
			// get a ref to the exercise and listen to changes
			let ref = fb.competitionMatrix2ExCollection
				.where('pid', '==', this.id)
				.where('uid', '==', this.uid);
			ref
				.get()
				.then((result) => {
					let items = [];
					result.docs.forEach((doc) => {
						let post = doc.data();
						items.push(post);
					});
					if (items) {
						this.doc = items[0].doc.matrix;
						console.log('success');
					} else {
						console.log('no items');
					}
				})
				.catch(function() {
					console.log('error');
				});
		},
	},
};
</script>

<style lang="scss">
.relative {
	position: relative;
	width: 100%;
	// min-height: 100vh;
}
.fixed-top {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
}
.z-0 {
	z-index: 0;
}
.z-1 {
	z-index: 1;
}
</style>
